import React, { useState, useRef } from "react";
import { Input } from "./Input";
import { LabelField } from "./LabelField";
import { SemanticMap } from "../../../services/stationApi";

interface SemanticMapAutocompleteProps {
  value: string;
  onChange: (value: string) => void;
  options: SemanticMap[];
  onSelect: (option: SemanticMap) => void;
  selectedOption?: SemanticMap | null;
  labelText?: string;
  placeholder?: string;
  isRequired?: boolean;
}

export const SemanticMapAutocomplete: React.FC<
  SemanticMapAutocompleteProps
> = ({
  value,
  onChange,
  options,
  onSelect,
  selectedOption,
  labelText = "Semantic Map",
  placeholder = "Type to search semantic map",
  isRequired = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  // Fecha o dropdown ao clicar fora
  React.useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredOptions = value
    ? options.filter((map) =>
        map.name.toLowerCase().includes(value.toLowerCase())
      )
    : options;

  return (
    <div
      style={{ position: "relative", width: "100%", marginBottom: "1rem" }}
      ref={wrapperRef}
    >
      {labelText && (
        <LabelField labelText={labelText} isRequired={isRequired} />
      )}
      <Input
        value={value}
        placeholder={placeholder}
        changeAction={(val) => {
          onChange(val);
          setIsOpen(true);
        }}
      />
      {isOpen && filteredOptions.length > 0 && (
        <div
          style={{
            maxHeight: 200,
            overflowY: "auto",
            border: "1px solid #ccc",
            borderRadius: 4,
            background: "#fff",
            position: "absolute",
            zIndex: 100,
            width: "100%",
            top: "100%",
            marginTop: 4,
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          {filteredOptions.slice(0, 50).map((map) => (
            <div
              key={map.id}
              style={{
                padding: "0.5rem",
                cursor: "pointer",
                background:
                  selectedOption?.id === map.id ? "#e6f7ff" : undefined,
              }}
              onMouseDown={() => {
                onSelect(map);
                onChange(map.name);
                setIsOpen(false);
              }}
            >
              {map.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
